import * as React from "react";
import {
  List,
  Datagrid,
  ListProps,
  DateField,
  FunctionField,
  downloadCSV
} from "react-admin";
import Pagination from "../Components/Pagination";
import OrderSearchPanel from "./OrderSearchPanel"
import { ApolloClient, InMemoryCache, gql } from '@apollo/client';
// @ts-ignore
import { unparse as convertToCSV } from 'papaparse/papaparse.min';
import { convertBasketItemsToString } from './OrderUtil'
import { TopToolbar } from 'react-admin'
import { Button } from '@material-ui/core'

const ListActions = (props: any) => {
  return (
    <TopToolbar>
      <Button color="primary" href={process.env.REACT_APP_AUTH_PUBLIC_PATH + "/#/Order/create"}>جدید</Button>
    </TopToolbar>
  )
};

const exporter = (orders: any) => {
  console.log('orders: ', orders);
  const ordersForExport = orders.map((order: any) => {
    let result = { ...order }
    result.customer = order?.customer?.firstName + ' ' + order?.customer?.lastName
    result.customerMobile = order?.customer?.mobile
    result.orderStatuses = order?.orderStatuses[0]?.status
    result.createdDateTime = new Date(order?.createdAt).toLocaleString('fa-IR-u-nu-latn')
    return result;
  });
  const csv = convertToCSV({
    data: ordersForExport,
    // select and order fields in the export
    fields: ['customer', 'customerMobile', 'orderStatuses', 'createdDateTime']
  });
  const BOM = '\uFEFF'
  downloadCSV(`${BOM} ${csv}`, 'orders' + new Date().toLocaleDateString('fa-IR-u-nu-latn').replaceAll('/', '')); // download as 'posts.csv` file
}

// let token: any = localStorage.getItem('credentials')
// const client = new ApolloClient({
//   uri: `${process.env.REACT_APP_DATAPROVIDER}`,
//   headers: { authorization: token },
//   cache: new InMemoryCache(),
// });

const getLastOrderStatus = (orderStatuses: Array<any>) => {
  var lastStatus = orderStatuses.slice(-1)[0];//allOrderStatuses.find((os: any) => os.id === lastCurrentOrderStatus?.id);
  var statusTitle = ""

  switch (lastStatus?.status) {
    case "Created": {
      statusTitle = "ارسال پیامک";
      break;
    }
    case "PaymentSuccess": {
      statusTitle = "پرداخت موفق";
      break;
    }
    case "PaymentFailure": {
      statusTitle = "پرداخت ناموفق";
      break;
    }
    default: {
      statusTitle = "ارسال پیامک";
      break;
    }
  }
  return statusTitle;
}

export const OrderList = (props: ListProps): React.ReactElement => {
  const [myFilter, setFilter] = React.useState({
    orderStatuses: { some: { status: "PaymentSuccess" } }
  });

  const getMobile = (record: any) => {
    if(record.customer && record.customer.authMethods && record.customer.authMethods.length > 0 && record.customer.authMethods[0].mobile)
      return record.customer.authMethods[0].mobile
    return "-"
  }

  return (
    <>
      <OrderSearchPanel handleSearch={setFilter} />
      <List
        {...props}
        bulkActionButtons={false}
        title={"لیست سفارشات"}
        perPage={50}
        filter={myFilter}
        // filters={orderFilter}
        pagination={<Pagination />}
        sort={{ field: 'createdAt', order: 'DESC' }}
        exporter={exporter}
      // actions={<ListActions />}
      >
        <Datagrid rowClick="show">
          <FunctionField
            label="خریدار"
            render={(record: any) => record?.customer ? `${record.customer.firstName} ${record.customer.lastName}` : '-'}
            sortable={false}
          />
          <FunctionField
            label="شماره خریدار"
            render={(record: any) => getMobile(record)}
            sortable={false}
          />
          <FunctionField
            label="محصولات"
            render={(record: any) => convertBasketItemsToString(record.basketItems)}
            sortable={false}
          />
          <FunctionField
            label="وضعیت سفارش"
            render={(record: any) => getLastOrderStatus(record.orderStatuses)}
          />
          <DateField source="updatedAt" label="تاریخ به‌روزرسانی" showTime={true} locales="fa-IR" />
          <DateField source="updatedAt" label="تاریخ به‌روزرسانی (میلادی)" />
        </Datagrid>
      </List>
    </>
  );
};
